import { Component, OnInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { TraceClassDecorator } from '@sentry/angular';
import { DoctorsService } from 'src/app/services/doctors.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { TokenService } from '../../../../utilities/token.service';
import { DoctorMenuService } from '../app.menu.service';
import { DoctorBreadcrumbService } from '../breadcrumb.service';
import { ProviderStateService } from 'src/app/services/provider-state.service';


@TraceClassDecorator()
@Component({
    selector: 'app-medical-profession-dashboard',
    templateUrl: './medical-profession-dashboard.component.html',
    styleUrls: ['./medical-profession-dashboard.component.css'
        , '../../../../../assets/css/custom-egd.css'
    ]
})
export class MedicalProfessionDashboardComponent implements OnInit {

    name: string;
    email: string;
    RefreshToken: string;
    // Activated: boolean;
    // Membership_data: string = "Activate Membership";
    avatar_url = "";
    notifications: number = 78;
    userid: string;
    slug: string="";
    user: any;
    layoutMode = 'static';

    megaMenuMode = 'dark';

    menuMode = 'gradient';

    profileMode = 'top';

    topbarMenuActive: boolean;

    overlayMenuActive: boolean;

    staticMenuDesktopInactive: boolean;

    staticMenuMobileActive: boolean;

    menuClick: boolean;

    topbarItemClick: boolean;

    activeTopbarItem: any;

    menuHoverActive: boolean;

    rightPanelActive: boolean;

    rightPanelClick: boolean;

    megaMenuActive: boolean;

    megaMenuClick: boolean;

    usermenuActive: boolean;

    usermenuClick: boolean;

    activeProfileItem: any;

    currentRoleID: number = 0;

    currentRoleIDLabel: string = "";

    base_url: string = "";
    edit_url: string = "";


    constructor(
        private readonly router: Router,
        private readonly doctorservice: DoctorsService,
        public renderer: Renderer2,
        private readonly menuService: DoctorMenuService,
        private readonly utilitiesService: UtilitiesService,
        private readonly tokenUtil: TokenService,
        private readonly providerstateService: ProviderStateService
    ) {
        
        
    }

    isRefreshAvialable(): boolean {
        return this.utilitiesService.isRefreshAvialable()
    }

    async ngOnInit(): Promise<void> {
        this.slug = this.providerstateService.getProviderSlug();
        this.base_url = this.utilitiesService.getBaseUserURL(this.router.url, 2)
        
        this.utilitiesService.reloadSessionStorage();
        if (!this.isRefreshAvialable()) {
            this.email = sessionStorage.getItem('email');
            this.userid = sessionStorage.getItem('userid');
            this.currentRoleID = this.tokenUtil.findRoleId();
            if (this.userid == null || this.email == null) {
                this.router.navigate(['/notfound']);
                return;
            }
            if (this.currentRoleID == 8) {
                this.edit_url = "/" + this.base_url + "/dashboard";
            } else if (this.currentRoleID == 9) {
                this.edit_url = "/" + this.base_url + "/dashboard";
            }
            else {
                this.edit_url = "/" + this.base_url + "/edit";
            }
            
            // { role_id: 1, name: 'Doctor' },
            // { role_id: 2, name: 'Admin' },
            // { role_id: 3, name: 'Super Admin' },
            // { role_id: 4, name: 'Super Admin Doctor' },
            // { role_id: 5, name: 'Admin Doctor' },
            if (this.currentRoleID == 1) {
                this.currentRoleIDLabel = 'Doctor';
            }
            else if (this.currentRoleID == 2) {
                this.currentRoleIDLabel = 'Admin';
            }
            else if (this.currentRoleID == 3) {
                this.currentRoleIDLabel = 'Super Admin';
            }
            else if (this.currentRoleID == 4) {
                this.currentRoleIDLabel = 'Super Admin Doctor';
            }
            else if (this.currentRoleID == 5) {
                this.currentRoleIDLabel = 'Admin Doctor';
            }
            else if (this.currentRoleID == 6) {
                this.currentRoleIDLabel = 'Other Medical Staff';
            }
            else if (this.currentRoleID == 7) {
                this.currentRoleIDLabel = 'Other Medical Staff Admin';
            }
            else if (this.currentRoleID == 8) {
                this.currentRoleIDLabel = 'Support Staff';
            }
            else if (this.currentRoleID == 9) {
                this.currentRoleIDLabel = 'Vendor';
            }
            await this.doctorservice.getDoctorprofile(this.userid).toPromise()
                .then(result => {
                    if (result.success) {
                        this.user = result.data;
                        this.name = this.user.first_name + " " + this.user.last_name;
                    }
                    this.avatar_url = result.data.avatar_url;
                }).catch(error => {

                });
        }
    }

    onLayoutClick() {
        if (!this.topbarItemClick) {
            this.activeTopbarItem = null;
            this.topbarMenuActive = false;
        }

        if (!this.rightPanelClick) {
            this.rightPanelActive = false;
        }

        if (!this.megaMenuClick) {
            this.megaMenuActive = false;
        }

        if (!this.usermenuClick && this.isSlim()) {
            this.usermenuActive = false;
            this.activeProfileItem = null;
        }

        if (!this.menuClick) {
            if (this.isHorizontal() || this.isSlim()) {
                this.menuService.reset();
            }

            if (this.overlayMenuActive || this.staticMenuMobileActive) {
                this.hideOverlayMenu();
            }

            this.menuHoverActive = false;
        }

        this.topbarItemClick = false;
        this.menuClick = false;
        this.rightPanelClick = false;
        this.megaMenuClick = false;
        this.usermenuClick = false;
    }

    onMenuButtonClick(event) {
        this.menuClick = true;
        this.topbarMenuActive = false;

        if (this.layoutMode === 'overlay') {
            this.overlayMenuActive = !this.overlayMenuActive;
        } else {
            if (this.isDesktop()) {
                this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
            } else {
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
            }
        }

        event.preventDefault();
    }

    onMenuClick($event) {
        this.menuClick = true;
    }

    onTopbarMenuButtonClick(event) {
        this.topbarItemClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;

        this.hideOverlayMenu();

        event.preventDefault();
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = false;

        if (this.activeTopbarItem === item) {
            this.activeTopbarItem = null;
        } else {
            this.activeTopbarItem = item;
        }

        event.preventDefault();
    }

    onTopbarSubItemClick(event) {
        event.preventDefault();
    }

    onRightPanelButtonClick(event) {
        this.rightPanelClick = true;
        this.rightPanelActive = !this.rightPanelActive;
        event.preventDefault();
    }

    onRightPanelClick() {
        this.rightPanelClick = true;
    }

    onMegaMenuButtonClick(event) {
        this.megaMenuClick = true;
        this.megaMenuActive = !this.megaMenuActive;
        event.preventDefault();
    }

    onMegaMenuClick() {
        this.megaMenuClick = true;
    }

    hideOverlayMenu() {
        this.overlayMenuActive = false;
        this.staticMenuMobileActive = false;
    }

    isTablet() {
        const width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    isMobile() {
        return window.innerWidth <= 640;
    }

    isHorizontal() {
        return this.layoutMode === 'horizontal';
    }

    isSlim() {
        return this.layoutMode === 'slim';
    }

    isOverlay() {
        return this.layoutMode === 'overlay';
    }

}
